module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Extrabld.81fe6b2e7aaa76d00ac595d8e0d5e024.woff";